// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.ngx-dropdown-container {
  width: 100%;
  position: relative;
}
.ngx-dropdown-container button {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  line-height: 1.42857143;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #333;
  background-color: #fff;
}
.ngx-dropdown-container button span:not(.nsdicon-angle-down) {
  vertical-align: middle;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.ngx-dropdown-container button .nsdicon-angle-down {
  position: relative;
  font-size: large;
  flex: 0 0 auto;
  margin-left: auto;
}
.ngx-dropdown-container .ngx-dropdown-button {
  font-family: inherit;
  font-size: 14px;
  color: #495057;
  width: 100%;
  min-height: 38px;
  padding: 5px 10px 5px 10px;
  background-color: white;
}
.ngx-dropdown-container .ngx-dropdown-list-container {
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 999999999;
  width: 350px;
  background-clip: padding-box;
  background: white;
  position: absolute;
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.21);
  overflow-y: auto;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container {
  position: relative;
  padding-top: 10px;
  margin-top: 5px;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container input {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #9e9e9e;
  border-radius: 0;
  outline: none;
  height: 2rem;
  width: 100%;
  font-size: 13px;
  margin: 0;
  padding: 0;
  box-shadow: none;
  box-sizing: content-box;
  transition: all 0.3s;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container input:focus {
  border-bottom: 1px solid #26a69a;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container input:focus + label {
  transform: translateY(-2px) scale(0.8);
  transform-origin: 0 0;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container label {
  color: #9e9e9e;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  font-size: 1rem;
  cursor: text;
  transition: transform 0.2s ease-out;
  transform-origin: 0% 100%;
  text-align: initial;
  transform: translateY(12px);
  pointer-events: none;
}
.ngx-dropdown-container .ngx-dropdown-list-container .search-container label.active {
  transform: translateY(-2px) scale(0.8);
  transform-origin: 0 0;
}
.ngx-dropdown-container .ngx-dropdown-list-container ul {
  margin-top: 1rem;
  margin-bottom: 1rem;
  list-style-type: none;
  padding-left: 0px;
}
.ngx-dropdown-container .ngx-dropdown-list-container ul.selected-items li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: #337ab7;
  color: white;
  margin-bottom: 2px;
}
.ngx-dropdown-container .ngx-dropdown-list-container ul.available-items li.active {
  background-color: #337ab7;
  color: white;
}
.ngx-dropdown-container .ngx-dropdown-list-container ul li {
  font-size: inherit;
  cursor: pointer;
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: normal;
}
.ngx-dropdown-container .disabled {
  pointer-events: none;
  background-color: #e9ecef;
  opacity: 1;
  cursor: no-drop;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
